import Grid from '@mui/material/Grid';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { useTranslation } from 'react-i18next';
import { useAudienceInsights } from '../../context/audienceInsights.ts';
import { ConnectedTv, Desktop, MobileApp, Tablet } from '../InsightItem/Icons.tsx';
import { InsightItem } from '../InsightItem/InsightItem.tsx';

export function MonthlyDeviceEstimates() {
  const { t } = useTranslation();
  const { statistics } = useAudienceInsights();

  return (
    <FormSection divider title={t('Monthly Device Estimates')}>
      <Grid container rowSpacing={8}>
        <Grid size={3}>
          <InsightItem
            title={t('Desktop')}
            icon={<Desktop />}
            value={statistics.totalDesktop}
            dataTestId="insight-device-desktop"
          />
        </Grid>

        <Grid size={3}>
          <InsightItem
            title={t('Mobile App')}
            icon={<MobileApp />}
            value={statistics.totalMobileApp}
            dataTestId="insight-device-mobile-app"
          />
        </Grid>

        <Grid size={3}>
          <InsightItem title="CTV" icon={<ConnectedTv />} value={statistics.totalCTV} dataTestId="insight-device-ctv" />
        </Grid>

        <Grid size={3}>
          <InsightItem
            title={t('Tablets')}
            icon={<Tablet />}
            value={statistics.totalTablets}
            dataTestId="insight-device-tablets"
          />
        </Grid>
      </Grid>
    </FormSection>
  );
}
